/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Gateway_Sub_Plan_Card_Days_RemainingInputs */



/**
* | output |
* | --- |
* | "{days} days remaining" |
*
* @param {Gateway_Sub_Plan_Card_Days_RemainingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_sub_plan_card_days_remaining = /** @type {((inputs: Gateway_Sub_Plan_Card_Days_RemainingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Sub_Plan_Card_Days_RemainingInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Noch ${i?.days} Tage`)
	return /** @type {LocalizedString} */ (`${i?.days} days remaining`)
});